import PropTypes from 'prop-types'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'

import { isNoneChartMode } from '@aytm/app/stats/page/question-views/components/lib/chart-modes'
import { isComponentOn } from '@aytm/app/stats/page/question-views/components/lib/utils'
import { calcChartTableProps } from '@aytm/app/stats/page/question-views/sh/lib/chart-table-utils'

// components
import ChartPlaceholder from '@aytm/app/stats/page/question-views/components/charts/placeholders/Chart'
import Table from '@aytm/app/stats/components/data-views/table/components/Table'
import Controls from '@aytm/app/stats/page/question-views/sh/components/chart/Controls'
import Chart from '@aytm/app/stats/page/question-views/sh/components/chart/Chart'

// The product-metrics half of a shelf-test question: the view picker, the chart and the
// per-product table. Collapsing hides the chart and the table, not the controls.
const ChartBlock = ({
  id,
  components,
  showPrice,
  chartCollapsed,
  isAnimated,
  percentDecimals,
  clickable,
  onModelChange,
  onChartCollapsedChange,
  onLabelClick,
  onSort,
  ...chartProps
}) => {
  const { viewMode, sortOrder, answer, answerVariants, priceTemplate, trait, traitName, isTraitType } = chartProps

  const tableProps = calcChartTableProps({
    id,
    answer,
    answerVariants,
    viewMode,
    sortOrder,
    percentDecimals,
    priceTemplate,
    trait,
    traitName,
    isTraitType,
    clickable,
    onLabelClick,
    onSort
  })

  return (
    <>
      {isComponentOn(components, 'controls') && (
        <Controls
          showPrice={showPrice}
          viewMode={viewMode}
          chartCollapsed={chartCollapsed}
          onModelChange={onModelChange}
          onToggle={onChartCollapsedChange}
        />
      )}
      {!chartCollapsed && (
        <>
          {isComponentOn(components, 'chart') &&
            !isNoneChartMode(chartProps.modelChartMode, chartProps.globalChartMode) && (
              <ChartPlaceholder isLoading={'loading' === answer} isAnimated={isAnimated}>
                <Chart questionId={id} {...chartProps} />
              </ChartPlaceholder>
            )}
          {isComponentOn(components, 'table') && <Table id={id} {...tableProps} />}
        </>
      )}
    </>
  )
}

ChartBlock.displayName = 'ShelfTestChartBlock'

ChartBlock.propTypes = {
  id: PropTypes.string,
  components: PropTypes.object,
  showPrice: PropTypes.bool,
  chartCollapsed: PropTypes.bool,
  isAnimated: PropTypes.bool,
  percentDecimals: PropTypes.number,
  clickable: PropTypes.bool,
  viewMode: PropTypes.string,
  answer: answerPropType,
  answerVariants: PropTypes.array,
  priceTemplate: PropTypes.string,
  trait: PropTypes.object,
  traitName: PropTypes.string,
  isTraitType: PropTypes.bool,
  onModelChange: PropTypes.func,
  onChartCollapsedChange: PropTypes.func,
  onLabelClick: PropTypes.func
}

export default ChartBlock
